import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { classes } from '~utils/Classes';

import { SocialIcon } from './SocialIcon';

export interface ISocialBannerProps {
    providerName: string;
    bannerText: string;
}

const SocialBannerWrapper = styled.div`
    text-align: center;
`;

const SocialBannerLogo = styled.div`
    display: inline-block;
    vertical-align: middle;
`;

const SocialBannerText = styled.h3`
    display: inline-block;
    text-transform: capitalize;
`;

const socialBannerWrapperClass = classes('iam-social-banner-wrapper');
const socialBannerTextClass = classes('iam-social-banner-text');

export const SocialBanner = observer((props: ISocialBannerProps) => {
    const { providerName, bannerText } = props;
    const bannerLogoClass = classes(`iam-social-banner-${providerName}`, 'elc-iam-social-banner');

    return (
        <SocialBannerWrapper className={socialBannerWrapperClass}>
            <SocialBannerLogo className={bannerLogoClass}>
                <SocialIcon providerName={providerName} />
            </SocialBannerLogo>
            <SocialBannerText className={socialBannerTextClass}>{bannerText}</SocialBannerText>
        </SocialBannerWrapper>
    );
});
